import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LiaCheckSquareSolid } from "react-icons/lia";
import "./finishRegistration.css";

export default function FinishRegistration() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(async () => {
      try {
        let token =
          localStorage.getItem("accessToken") ||
          localStorage.getItem("token");

        if (!token) {
          navigate("/sign-in", { replace: true });
          return;
        }

        localStorage.setItem("accessToken", token);

        navigate("/profile", { replace: true });
      } catch (err) {
        console.error("❌ Redirect failed:", err);
        navigate("/sign-in", { replace: true });
      }
    }, 2500);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="finish-wrapper">
      <div className="finish-card">
        <div className="finish-container">
          <div className="finish-icon">
            <LiaCheckSquareSolid className="finish-check-icon" />
          </div>
          <div className="finish-title-block">
            <p className="finish-subtitle">You are successfully</p>
            <p className="finish-title">Registered!</p>
          </div>
        </div>
      </div>

      <footer className="finish-footer">
        <span>© 2025 Halper. All rights reserved.</span>
        <div className="footer-links">
          <a href="#">Privacy</a>
          <a href="#">Get help</a>
        </div>
      </footer>
    </div>
  );
}
